import { queryClient } from '@src/api/queryClient';
import { LOOKUP_QUERY_KEYS } from '@src/api/services/lookup/query';
import { RequestTypeStringsLookup, RequestTypeIds } from '@src/utils/enums';
import { FormVersionRow, LookupTablesData } from '@api/services/lookup/types';

export const getLatestFormVersionFromLookup = (args: {
  requestTypeId: number;
  formVersions?: FormVersionRow[] | null;
}): number | undefined => {
  const { requestTypeId, formVersions } = args;

  const lookupName = RequestTypeStringsLookup[requestTypeId];
  if (!lookupName) return undefined;

  const row = formVersions?.find((r) => r.requestType === lookupName);
  return row?.formVersion && row.formVersion > 0 ? row.formVersion : undefined;
};

export const getLatestFormVersionByRequestType = (requestTypeId: number): number | undefined => {
  const lookupTableData = queryClient.getQueryData<LookupTablesData>([LOOKUP_QUERY_KEYS.GET_ALL_TABLES]);
  const formVersions: FormVersionRow[] = lookupTableData?.FormVersions ?? [];

  return getLatestFormVersionFromLookup({
    requestTypeId,
    formVersions,
  });
};

export const nprVariantByRequestType: Partial<Record<number, 'npr' | 'abNpr'>> = {
  [RequestTypeIds.NoPermitRequired]: 'npr',
  [RequestTypeIds.ActivityBasedNoPermitRequired]: 'abNpr',
};
